<template>
  <div>
    <div v-for="(item, index) in modelValue" :key="index">
      <v-list lines="one" class="pa-0">
        <v-list-item :style="`margin-left: ${level}px`" class="my-0 py-0">
          <v-list-item-title>
            <v-row>
              <v-col cols="6">
                <v-text-field
                              v-if="!item.id || item.editing"
                              v-model="item.name"
                              label="Nome"
                              hide-details
                              density="compact"
                              width="300px"></v-text-field>
                <span v-else>{{ item.name }}</span>
              </v-col>
              <v-col cols="2">
                <v-text-field v-if="!item.id || item.editing"
                              v-model="item.start_at"
                              label="Inicia em:"
                              hide-details
                              type="date"
                              density="compact"></v-text-field>
                <span v-else>De: {{ $moment.parseZone(item.start_at).format('DD/MM/YYYY') }}</span>
              </v-col>
              <v-col cols="2">
                <v-text-field v-if="!item.id || item.editing"
                              v-model="item.end_at"
                              label="Termina em:"
                              hide-details
                              type="date"
                              density="compact"></v-text-field>
                <span v-else>Até: {{ item.end_at ? $moment.parseZone(item.end_at).format('DD/MM/YYYY') : 'Indeterminado'
                }}</span>
              </v-col>
              <v-col cols="2" class="text-right">
                <v-autocomplete
                                v-if="!item.id || item.editing"
                                v-model="item.type"
                                :items="visibleCashflowCategories"
                                item-title="label"
                                item-value="value"
                                hide-details
                                density="compact"
                                label="Tipo"
                                clearable>
                  <template v-slot:no-data>
                    <div class="px-4">Digite sua busca</div>
                  </template></v-autocomplete>
                <v-chip v-else class="ml-2">{{
                  $CASH_FLOW_CATEGORY_TYPES_DIC[item.type].label
                }}</v-chip>
              </v-col>
            </v-row>
          </v-list-item-title>
          <template v-slot:prepend>
            <v-btn v-if="item[childrenKey] && item[childrenKey].length > 0"
                   icon
                   variant="text"
                   @click="item.showTree = !item.showTree"><v-icon>{{ !item.showTree ? 'mdi-chevron-up' :
                     'mdi-chevron-down' }}</v-icon>
            </v-btn>
            <v-btn v-else-if="!item.id && item[childrenKey].length == 0"
                   icon
                   variant="text"
                   color="red"
                   @click="modelValue.splice(index, 1)">
              <v-icon>mdi-minus</v-icon>
            </v-btn>
            <v-icon v-else>mdi-minus</v-icon>
          </template>
          <template v-slot:append>
            <v-btn
                   color="primary"
                   icon
                   variant="text"
                   :disabled="!canEdit(item)"
                   @click="beginEdit(item)"><v-icon>mdi-pencil</v-icon></v-btn>
            <v-btn
                   color="orange"
                   icon
                   variant="text"
                   :disabled="!canAdd(item)"
                   @click="addItem(item, childrenKey)"><v-icon>mdi-tray-plus</v-icon></v-btn>
          </template>
        </v-list-item>
      </v-list>

      <div class="py-0">
        <v-slide-y-transition group>
          <TreeView v-if="!item.showTree"
                    :user="user"
                    v-model="item[childrenKey]"
                    :childrenKey="childrenKey"
                    :level="level + 20"
                    @itemAdded="$emit('itemAdded')" />
        </v-slide-y-transition>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    user: Object,
    modelValue: Array,
    childrenKey: String,
    level: Number,
  },
  emits: ["update:modelValue", 'itemAdded'],
  data() {
    return {};
  },
  created() { },
  mounted() { },
  activated() { },
  methods: {
    addItem(item, childrenKey) {
      const vm = this;

      item[childrenKey].push({
        sub_categories: [],
        start_at: vm.$moment.parseZone().format('YYYY-MM-DD'),
        end_at: undefined,
        admin_locked: 0
      })
      vm.$emit("itemAdded");
    },
    beginEdit(item) {
      item.editing = true;
      this.$emit("itemAdded");
    },
    canEdit(item) {
      if (item.editing || !item?.id) {
        return false;
      }
      const vm = this;

      if (vm.hasAdminAccess) {
        return true;
      }
      return item.admin_locked === 0;
    },
    canAdd(item) {
      if (item.editing || !item?.id) {
        return false;
      }
      const vm = this;

      if (vm.hasAdminAccess) {
        return true;
      }
      return item.parent_category != null;
    },
  },
  computed: {
    visibleCashflowCategories() {
      const vm = this;

      return vm.$CASH_FLOW_CATEGORY_TYPES.filter(c => c.value < 3);
    },
    hasAdminAccess() {
      return this.user.access_level >= this.$USER_ACCESS_LEVELS_DIC.ADMIN.value;
    },
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
};
</script>